<div style="display: flex;
justify-content: center;
align-items: center;
height: 100vh;">
<h3>
  ربما تم إعادة توجيهك إلى الرابط الخطأ.
</h3>

<br>
  <a [href]="'/sa/' + from + '/attempt/' + surveyAssessmentId">
    <button pButton>
      انقر هنا لإعادة التوجيه
    </button>
  </a>

</div>
